import { Avatar, Box, Button, Dialog, DialogActions, Grid, IconButton } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "styled-components";
import { IDraggableAlignmentResultSection, ISectionGroup, SectionGroup } from "store/types";

interface IProps {
  open: boolean;
  onClose: () => any;
  state: any;
}

const style = {
  height: "280px",
  width: "530px",
  bgcolor: "#FFFFFF",
  boxShadow: "0px 8px 32px rgba(0, 0, 0, 0.16)",
  borderRadius: "8px",
  p: 4,
};

const PageTitle = styled.legend`
  font-family: "Roboto", sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
`;

const ActionButton = styled(Button)`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  padding: 12px 16px;
`;

const countModules = (sectionGroup?: ISectionGroup) => {
  let count = 0;
  sectionGroup &&
    sectionGroup.sections.forEach((section: IDraggableAlignmentResultSection) => {
      count += section.resourceIds.length;
    });
  return count;
};

export const RulesResultsDialog = ({ open, onClose, state }: IProps) => {
  const sorted =
    state && state.sectionGroups.find((sectionGroup: ISectionGroup) => sectionGroup.name === SectionGroup.SORTED);
  const unsorted =
    state && state.sectionGroups.find((sectionGroup: ISectionGroup) => sectionGroup.name === SectionGroup.UNSORTED);
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="confirm-dialog">
      <Box sx={style}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={1}>
            {
              <Avatar sx={{ backgroundColor: "#DFF9D2" }}>
                <CheckCircleOutlineIcon sx={{ color: "#398712" }} />
              </Avatar>
            }
          </Grid>
          <Grid item xs={10}>
            <PageTitle>Automatic alignment complete!</PageTitle>
          </Grid>
          <Grid item xs={1} style={{ display: "flex", alignItems: "center" }}>
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                color: "#414141",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
        <p>Here are the results:</p>
        <ul>
          <p>
            <li>
              <strong>Sorted:</strong>&nbsp;{countModules(sorted)} content items
            </li>
            <li>
              <strong>Unsorted:</strong>&nbsp;{countModules(unsorted)} content items
            </li>
          </p>
        </ul>
        <p>Please double check the results. You can manually move content items to their correct location.</p>
        <DialogActions sx={{ paddingRight: "0px", paddingTop: "24px", paddingBottom: "16px" }}>
          <ActionButton variant="contained" onClick={onClose}>
            Got it
          </ActionButton>
        </DialogActions>
      </Box>
    </Dialog>
  );
};
